var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.69 14.8",
    fill: "#d1d3d4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.46,6.82,1.87.24A.76.76,0,0,0,1.3,0,.76.76,0,0,0,.73.24L.24.72a.83.83,0,0,0,0,1.15L5.77,7.4.24,12.93A.78.78,0,0,0,0,13.5a.8.8,0,0,0,.24.58l.48.48a.82.82,0,0,0,.57.24.84.84,0,0,0,.58-.24L8.46,8a.83.83,0,0,0,0-1.15Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.4aab8c6860ba7ac89da6810dc2566c30.svg";
export { ForwardRef as ReactComponent };